export default {
  basicInfo: 'Temel Bilgiler',
  departments: 'Departmanlar',
  campus: 'Kampüs',
  providerCompany: 'Servis Şirketi',
  selectCampus: 'Kampüs Seçiniz',
  selectProviderCompany: 'Servis Şirketi Seçiniz',
  dateFormat: 'Tarih Formatı',
  company: 'Şirket',
  status: 'Durum',
  campuses: 'Kampüsler',
  routes: 'Rotalar',
  users: 'Kullanıcılar',
  registeredUsers: 'Kayıtlı Kullanıcılar',
  shuttleUsers: 'flexiShuttle Kullanıcıları',
  poolcarUsers: 'flexiCar Kullanıcıları',
  rideUsers: ' flexiRide Kullanıcıları',
  parkUsers: 'flexiPark Kullanıcıları',
  region: 'Bölge',
  locations: 'Kayıtlı Adresler',
  locationName: 'Adres adı',
  address: 'Adres',
  serviceProvider: 'Servis Şirketi',
  newServiceProvider: 'Yeni Servis Şirketi',
  addNewServiceProvider: 'Yeni Servis Şirketi Ekle',
  updateServiceProvider: 'Yeni Servis Şirketi Güncelle',
  admins: 'Yöneticiler',
  general: 'Genel',
  poolCarRide: 'flexiCar/flexiRide Private/ flexiRideShared ',
  flexiCarTab: 'flexiCar',
  flexiRidePrivateTab: 'flexiRide',
  onDemandTab: 'flexiRide Havuz ',
  onDemand2Tab: 'flexiRide Havuz 2',
  onDemand3Tab: 'flexiRide Havuz 3',
  parking: 'flexiPark',
  allowance: 'Ödenek',
  subCompanies: 'Alt Şirketler',
  pricing: 'Fiyatlandırma',
  settings: 'Ayarlar',
  noSubCompany: 'Alt şirket bulunamadı.',
  newCampus: 'Yeni Kampüs',
  addNewCampus: 'Yeni Kampüs Ekle',
  newRegion: 'Yeni Bölge',
  newLocation: 'Yeni Konum',
  newAdmin: 'Yeni Admin',
  campusName: 'Kampüs Adı',
  regionName: 'Bölge Adı',
  location: 'Lokasyon',
  editCampus: 'Kampüsü Düzenle',
  editRegion: 'Bölgeyi Düzenle',
  deleteCampus: 'Kampüsü Sil',
  noLocation: 'Konum bilgisini bulunamadı.',
  deleteRegion: 'Bölgeyi Sil',
  system: 'Sistem',
  systemAdmin: 'Sistem Admin',
  serviceProviderAdmin: 'Servis Şirketi Admini',
  newDepartment: 'Yeni Departman',
  addNewDepartment: 'Yeni Departman Ekle',
  departmentName: 'Departman Adı',
  departmentNumber: 'Departman Numarası',
  noDepartmentsAdded: 'Henüz bir departman eklenmedi',
  editDepartment: 'Departman Düzenle',
  number: 'Numara',
  phoneNumber: 'Telefon Numarası',
  drawCampusLocation: 'Kampüs konumunu tanımlamak için haritaya bir çokgen çizin.',
  drawRegionLocation: 'Bölge konumunu tanımlamak için haritaya bir çokgen çizin.',
  editCampusArea: 'Yerleşke alanını düzenlemek için poligonun köşe noktalarını uygun yerlere çekin.',
  editRegionArea: 'Bölge alanını düzenlemek için poligonun köşe noktalarını uygun yerlere çekin.',
  importKmlKmz: "KMZ/KML'den içe aktar",
  importNoPolygon: 'Seçilen dosyada çokgen bulunamadı.',
  importReadError: 'Dosya okunamadı. Lütfen geçerli bir KMZ/KML dosyası seçin.',
  campusesDeleted: 'Üzerinde kayıtlı yolcuların ve/veya aktif rota gruplarının bulunduğu kampüsler silinemez.',
  industries: {
    IT: 'Bilişim Teknolojileri',
    Education: 'Eğitim',
    'Sales&CRM': 'Satış ve Müşteri İlişkileri',
    Finance: 'Finans',
    'Design and Creative': 'Tasarım',
    Marketing: 'Pazarlama',
    Operations: 'Operasyon',
    Construction: 'İnşaat ve Yapı',
    'HR & Recruiting': ' İnsan Kaynakları',
    'Software Development': 'Yazılım Geliştirme',
    Legal: 'Hukuk',
    Other: 'Diğer',
  },
  basicInfoSubProps: {
    type: 'Tip',
    companyName: 'Şirket Adı',
    taxNumber: 'Vergi Numarası',
    industry: 'Endüstri',
    language: 'Dil',
    currency: 'Para Birimi',
    unit: 'Birim',
    functionality: 'Modüller',
  },
  functionalities: {
    usingPoolcar: 'flexiCar',
    usingRide: 'flexiRide',
    usingShuttle: 'flexiShuttle',
    usingTaxi: 'flexiMileage',
    usingVanPool: 'flexiVanpool',
    usingCarPool: 'flexiCarpool',
    seeCommuteOptions: 'Commute Options',
    usingSharedRide: 'flexiRide Shared',
    usingFlexiPark: 'flexiPark',
    feedback: 'Geri Bildirim',
    usingSharedRide2: 'flexiRide Shared 2',
    usingSharedRide3: 'flexiRide Shared 3',
    usingCampusBike: 'Kampüs Bisikleti',
    usingGuaranteedRideHome: 'Garantili Eve Dönüş',
    publicLink: 'Public Link',
  },
  publicLinkText: {
    publicLinkControl: 'Public Link Kontrolü',
    publicLink: 'Public link',
    showDriverInfo: 'Public link üzerinden sürücü bilgisi görüntülensin.',
    showDriverPhone: 'Public link üzerinden sürücünün telefon numarası görüntülensin.',
    showVehicleInfo: 'Public link üzerinden araç bilgisi görüntülensin.',
    showVehicleInfoAs: 'Araç bilgisi içinde plaka / araç ID bilgisi görüntülensin.',
    licensePlate: 'Plaka',
    vehicleId: 'Araç ID',
  },
  feedback: {
    userFeedbackCategoriesAndTopics: 'Kullanıcı Geri Bildirim Kategorileri ve Alt Başlıklar',
    noTopicsAdded: 'Alt konu başlığı eklenmedi',
    text1:
      'Her kategori için hazır sunulan konu listesinden başlıklar seçebilir ve isteğe bağlı olarak yeni konular ekleyebilirsiniz. Mobil uygulamada kullanılabilirlik açısından başlık sayısını en fazla 10 ile sınırlandırmanızı tavsiye ederiz.',
    newTopic: 'Yeni Konu Başlığı',
    walkingDistance: 'Yürüme Mesafesi',
    arrivedLate: 'Geç Geldi',
    leftEarly: 'Erken Ayrıldı',
    noShow: 'Gelmedi',
    driverBehavior: 'Sürücü Davranışı',
    vehicleCleanliness: 'Araç Temizliği',
    missingEquipment: 'Eksik Ekipman',
    checkinScan: 'Giriş Taraması',
    other: 'Diğer',
    newFeedback: 'Yeni Geri Bildirim',
    feedbackDetail: 'Geri Bildirim Detayı',
    anyFeedbackMessage: 'Henüz herhangi bir geri bildirim mesajı göndermediniz.',
    pleaseSelectDate:
      'Talebiniz belli bir olayla ilgili ise olay tarihini girebilir, değilse bugünün tarihiyle gönderebilirsiniz.',
    shareYourFeedback: 'Lütfen geri bildirimlerinizi bizimle paylaşın…',
    noMessage: 'Mesaj Yok',
  },
  generalText: {
    newUser: 'Yeni bir kullanıcı eklendiğinde hoşgeldin maili gönder.',
    emails: 'Kullanıcılara push, email ve sms bilgilendirmelerini gönder.',
    sendUsersEmail: 'Kayıt olduktan sonra kullanıcılara bilgilendirme maili gönder.',
    uniqueId: 'Kayıt sırasında kullanıcılardan sicil no bilgisi iste.',
    phoneNumberRequired: 'Telefon numarası alanı zorunludur.',
    displaySurvey: 'Kullanıcı oryantasyonunda anket göster',
    checkPersonel: 'Uygulama modülleri kullanıcıya göre ayarlansın.',
    dashboardShuttle: 'Servis Aracı',
    dashboardPoolcar: 'PoolCar',
    dashboardVanpool: 'Vanpool',
    dashboardTaxi: 'Taksi',
    dashboardRide: 'flexiRide',
    dashboardCalender: 'Takvim',
    dashboardPastUses: 'Geçmişteki Kullanımlar',
    dashboardCarpool: 'Carpool',
    dashboardComplaints: 'Mobil Uygulama Modülleri',
    emailSignatureShowCompanyName: 'E-posta imzasında şirket adını göster',
    mobileDashboardItems: 'Mobil Pano Öğeleri',
    request: 'Talep ve Öneri',
    dashboardLoop: 'Ring',
    firstLoginPickupReminder: 'Ev adresi alanı zorunlu olsun',
    changeHomeAddress: 'Personel ev adresi değişikliğinde adminlere email gönder',
    displayDriverInfoOnRiderApp: 'Mobil uygulamada kullanıcılara sürücü bilgisini göster.',
    selectCompanyDepartment: 'Kayıt sırasında kullanıcılardan şirket ve departman seçimi iste.',
    sharedRideModuleName: 'On Demand servisine ait modül adını şu şekilde görüntüle',
    onboardingAccessibilityInfo: 'Kayıt aşamasında kullanıcıların özel destek veya erişilebilirlik ihtiyaçlarını sor.',
    additionalSeat: 'Ek koltuk',
    autoAssignToWAVVehicle: 'WAV Aracına Otomatik Ata',
    newCategory: 'Yeni Kategori',
    sharedRideModuleName2: 'On Demand 2 servisine ait modül adını şu şekilde görüntüle',
    sharedRideModuleName3: 'On Demand 3 servisine ait modül adını şu şekilde görüntüle',
  },
  adminsText: {
    setTwoFactor: 'Yöneticiler için iki yönlü doğrulamayı aktif et',
    adminsRequests: 'İstekler ile alakalı bilgilendirilecek yöneticiler',
    placeHolder: 'Birden fazla email virgül ile ayırarak yazabilirsiniz',
  },
  poolCarRideText: {
    approvalFlexiCar: 'flexiCar için gerekli onay',
    shouldComplateDailyChecklist: 'Sürücüler günlük bir kontrol listesi doldurmalıdır',
    reservationFlexiCar: 'flexiCar için gerekli rezervasyon',
    approvalFlexiRide: 'flexiRide için gerekli onay',
    autoPlanning: 'Otomatik planlama',
    sendConfirmationEmail: 'flexiRide talepleri e-postalardan oluşturulduğunda asistanlara onaya gönder',
    notifyRidersflexiRideRequest: 'flexiRide istekleri için sürücü ve araç atandığında sürücüleri bilgilendirin.',
    notifyRidersPickupPoint: 'flexiRide aracı teslim alma noktasına vardığında personelleri bilgilendirin',
    sendUsersSMSLink: 'Kullanıcılara, aracı yolculuk saatlerinde takip etmeleri için bir SMS bağlantısı gönderin.',
    notifyDriverVehicleRequest: 'flexiRide istekleri için sürücü ve araç atandığında yardımcıları bilgilendirin.',
    notifyflexiRideVehicleArrives: 'flexiRide aracı teslim alma noktasına vardığında asistanları bilgilendirin',
    notifyflexiRideRequest: 'Talep onaylandığında/reddedildiğinde asistanları bilgilendirin.',
    SendSMSLinkTrackVehicleTripTimes:
      'Asistanlara, aracı yolculuk saatlerinde takip etmeleri için bir SMS bağlantısı gönderin.',
    flexiRidePurposes: 'flexiRide Amaçları',
    notifyApproachesPickupPoint:
      'flexiRide aracı toplama noktasına yaklaştığında, varmadan {time} dakika önce asistanları bilgilendirin.',
    notifyBeforeApproachesPickupPoint:
      'flexiRide aracı teslim alma noktasına yaklaştığında asistanları varıştan önce bilgilendirin.',
    notifyRidersApproachesPickupPoint:
      'flexiRide aracı teslim alma noktasına yaklaştığında binicilere varıştan {time} dakika önce haber verin.',
    notifyRidersBeforeApproachesPickupPoint:
      'flexiRide aracı teslim alma noktasına yaklaştığında binicilere varıştan önce haber verin',
    notifyBeforeArrival: 'Varış öncesi bildirim süresi',
    notifyRidersBeforeArrival: 'Varış öncesi bildirim süresi',
    purposeMustSelectedAdded: 'En az bir amaç seçilmeli veya eklenmelidir.',
    notifyRidersRequest: 'Talep onaylandığında/reddedildiğinde personelleri bilgilendirin.',
    notifyAdministratorsFlexiRideRequest: 'Yeni bir flexiRide isteği alındığında yöneticileri bilgilendirin.',
    riderForRequestAcknowledged: 'flexiRide talebi yönetici tarafından kabul edildiğinde personelleri bilgilendirin.',
    assistantForRequestAcknowledged:
      'flexiRide talebi yönetici tarafından kabul edildiğinde asistanları bilgilendirin.',
    mobilityAssistance: 'Kullanıcılar engelli yardımı talep edebilirler.',
    serviceTimeWithHoursMultiple: 'Bu hizmet {1} {0} arası verilmektedir.',
    requestsInAdvance: '{0} talepleri {mins} dk aralıklarla yapılabilir.',
    requestsInAdvanceLong: 'Talep aralıkları',
    sharedServiceTime: 'Her durak için hizmet süresi',
    serviceTimeWithHours: 'Bu hizmet {1}, {0} arası verilmektedir.',
    serviceTimeWithoutHours: 'Bu hizmet {0}, tüm gün boyunca verilmektedir.',
    singleRequest: 'Bir talep içinde en fazla seçilebilecek kişi sayısı',
    riders: 'kişi',
    reservationsEarliest: 'En erken havuz araç rezervasyon süresi',
    adaOptionForAdaStaffOnly: 'ADA seçeneği yalnızca ADA personeli için geçerlidir.',
    highDemandStopClassification: 'Yoğun Talep Gören Durak Sınıflandırması',
    highDemandExceedsThreshold:
      'Bir durağı kullanan yolcu sayısının saatlik ortalaması {count} kişiyi aşarsa bu durak yoğun talep görüyor sayılır',
    highDemandTopPercentage:
      "Bir durağı kullanan yolcu sayısının saatlik ortalaması tüm duraklar içinde en yoğun %{percentage}'lik dilime girerse bu durak yoğun talep görüyor sayılır",
    exceedsThreshold: 'Eşik değeri aşma',
    topPercentage: 'Yüzdelik dilim',
    pickupOtpBuffer: 'Biniş zamanları için OTP takibinde kullanılacak tolerans süresi',
    dropoffOtpBuffer: 'İniş zamanları için OTP takibinde kullanılacak tolerans süresi',
    avgDeviationWarningThreshold: 'Ortalama Sapma değerini aştığında dashboardda uyarı göster.',
    acceptanceRateWarningThreshold: 'Kabul Oranı değerinin altına düştüğünde dashboardda uyarı göster.',
    ridersPerHourWarningThreshold: 'Saat Başına Yolcu Sayısı değerinin altına düştüğünde dashboardda uyarı göster.',
    pickupOtpWarningThreshold: 'Biniş OTP değerinin altına düştüğünde dashboardda uyarı göster.',
    dropoffOtpWarningThreshold: 'İniş OTP değerinin altına düştüğünde dashboardda uyarı göster.',
    avgPickupDeviationWarningThreshold: 'Ortalama Biniş Sapması  değerini aştığında dashboardda uyarı göster.',
    avgDropoffDeviationWarningThreshold: 'Ortalama İniş Sapması değerini aştığında dashboardda uyarı göster.',
    theActiveTimesForFlexiRideSharedService: '{0} hizmetinin aktif olduğu gün ve saatler:',
    allDay: 'Tüm gün',
    duringSpecifiedHours: 'Belirtilen saatlerde',
    addPeriod: 'Periyot Ekle',
    phoneNumberRequiredFlexiRideSharedRequests: 'Taleplerde telefon numarası olması zorunlu',
    theStartingTimeMustEarlierThanTheEndingTime: 'Başlangıç saati bitiş saatinden daha erken olmalıdır',
    from: '',
    to: '-',
    weekdays: 'hafta içi tüm günler',
    runOptimizationBasedOn: {
      message: 'Talepleri araçlara ',
      vehicleCount: 'Eşit dağıtacak şekilde optimizasyonu çalıştır. ',
      maximumUtilization: 'Maksimum dolduracak şekilde optimizasyonu çalıştır.',
    },
    sharedRideCustomStop: 'Herhangi bir konumdan yolculuk talebine izin ver',
    recurringRequest: 'Tekrarlayan yolculuk taleplerine izin ver',
    futureThresholdInMin: 'Planlama Eşiği',
    futureThresholdInMinInfo:
      'Bu süre içinde başlayacak talepler hemen planlanır. Daha ileri tarihli talepler ise daha sonra planlanmak üzere bekletilir.',
    additionalRidersEnabled: 'Birden fazla yolcu için talep yapmaya izin ver',
  },
  requestStartTime: {
    earliestTime: 'Paylaşımlı sürücülü araç talepleri en erken ne zaman yapılabilir?',
    theSameDay: 'Aynı gün',
    inAdvance: 'Önceden',
    day: 'gün',
    days: 'gün',
    hour: 'saat',
    hours: 'saat',
    daysInAdvanceCount: 'Kaç gün önceden?',
    daysInAdvance: 'gün önce',
    sameDay: 'aynı gün',
    onTheDay: 'Aynı gün için yolculuk talebi yapılabilir.',
    daysEarlier: {
      single: 'gün önceden',
      multiple: 'gün önceden',
    },
    requestsCanBeMade: 'Yolculuk zamanından {0} itibaren talep yapılabilir.',
    theStartingTimeMustEarlierThanTheEndingTime: 'Başlangıç ​​saati bitiş saatinden daha erken olmalıdır',
    earliestBookingBeforeTrip: 'Yolculuktan önce en erken rezervasyon',
    latestBookingBeforeTrip: 'Yolculuktan önceki son rezervasyon',
    unit: 'Birim',
    dayUnit: 'Gün',
    hourUnit: 'Saat',
    dayValue: 'Gün değeri',
    hourValue: 'Saat değeri',
    pleaseEnterWholeNumber: 'Lütfen tam sayı girin.',
    minimumAdvanceBookingMustBeAtLeastOneHour: 'En erken talep süresi en az 1 saat olmalıdır.',
    earliestBookingMustBeGreaterThanLatest: 'En erken talep süresi en geç talep süresinden büyük olmalıdır',
    bookingWindowInfo: {
      withLatest: 'Talepler en erken {earliest}, en geç {latest} önce oluşturulabilir.',
      onlyEarliest: 'Talepler en erken {earliest} önce oluşturulabilir.',
      sameDay: 'Talepler aynı gün için oluşturulabilir.',
      sameDayWithLatest: 'Talepler aynı gün için en geç {latest} önce oluşturulabilir.',
      beforePickupTime: 'yolculuk zamanından önce',
    },
  },
  operationalHours: {
    title: '{serviceName} için hizmet saatleri',
    servicePeriod: 'Operasyon Saati {number}',
    addServicePeriod: 'Operasyon Saati Ekle',
    deletePeriod: 'Operasyon Saatini Sil',
    addHours: 'Saat Ekle',
    userProfile: 'Kullanıcı Profili',
    allUserProfiles: 'Tüm kullanıcı profilleri',
    noUserProfilesDefined: 'Tanımlı kullanıcı profili yok',
    defineUserProfilesFirst: 'Kullanıcı profillerini tanımlayıp ardından profil bazında hizmet erişimini kısıtlayın.',
    userProfileRequired: 'Lütfen her saat aralığı için bir kullanıcı profili seçin.',
    dayRequired: 'Lütfen en az bir gün seçin.',
    timeRequired: 'Lütfen tüm saat aralıklarını doldurun.',
    overlapError: 'Saat aralıkları kesişmemelidir. Lütfen saatleri düzenleyin.',
    crossDayOverlapError: 'Saat aralıkları başka bir operasyon saati ile kesişmemelidir. Lütfen saatleri düzenleyin.',
    weekends: 'hafta sonu',
    viewPrefix: 'Hizmet {periods} aktiftir.',
    viewPeriodHours: '{days} günleri {hours} saatleri arasında',
    viewPeriodAllDay: '{days} tüm gün',
  },
  flexiMileageText: {
    flexiMileageNotifications: 'flexiMileage Bildirimleri',
    flexiMileagePurposes: 'flexiMileage Amaçları',
    perMileCost: 'Mil Başına Maliyet',
    notifyRidersReportedMileageConfirmed: 'Bildirilen kilometreleri onaylandığında sürücüleri bilgilendirin.',
    notifyRidersReportedMileageRejected: 'Bildirilen kilometreleri reddedildiğinde sürücüleri bilgilendirin.',
    notifyRidersReportecMileagePaidBack: 'Bildirilen kilometre geri ödendiğinde sürücüleri bilgilendirin.',
    riderForComfirmed: 'Bildirilen kilometreleri onaylandığında sürücüleri bilgilendirin.',
    riderForRejected: 'Bildirilen kilometreleri reddedildiğinde sürücüleri bilgilendirin.',
    riderForPaidBack: 'Bildirilen kilometre geri ödendiğinde sürücüleri bilgilendirin.',
  },
  shuttleText: {
    userControl: 'Kullanıcı kontrolü',
    text1: 'Kullanıcıların diğer kampüslere giden rotaları görmesine izin ver',
    text2: 'Yönetici bildirimleri',
    text3: 'Araçlardan sinyal alınamadığında yöneticileri bilgilendir.',
    text4: 'Konuma ulaşmayan ya da geç ulaşan rotalar olduğunda yöneticileri bilgilendir',
    text5: 'Yöneticileri kart tarama yüzdeleri hakkında bilgilendir',
    notifyAdminsWhenNewRouteCreatedByOptimization:
      'Rota optimizasyonu tarafından yeni bir rota oluşturulduğunda yöneticileri bilgilendir.',
    cardScans: 'Kart/QR taramaları',
    text6:
      'Kart/QR {scanDays} gün boyunca taranmazsa, kullanıcı taramayı yeniden başlatmadığı sürece {emailDays} gün boyunca kullanıcılara günlük uyarı e-postaları gönderin.',
    cardQrNotScannedLimitBeforeWarning: 'Kart/QR taranmadan önce uyarı gün sayısı',
    warningCountBeforeTreatment: 'Uyarı e-postası gün sayısı',
    text7: 'Kart yada QR taranmadıysa kullanıcıyı flexiShuttle için pasif olarak ayarla',
    rules: 'Kurallar',
    text8: 'Rotaları sürücü uygulamasına gönder',
    serviceProviders: 'Servis Şirketi',
    text9: 'Servis şirketi için çalışan listesini görünür yap',
    text10: 'Servis şirketi için kampüs bazlı bildirim yollama kontrolünü aktif yap',
    text11: 'Araç Plakası',
    text12: 'Rota Id',
    text13: 'QR kodları {QrCodes} bilgisine göre oluşturulsun',
    text14: 'Servis otobüslerinin maksimum yaşı {maxVehicleAgeAllowed} yıl olmalıdır.',
    maxVehicleAgeAllowed: 'Servis otobüslerinin maksimum yaşı',
    text15: 'Sürücüler aranabilsin',
    text16: 'Servis şirketi tarafından yapılan araç ve sürücü atamalarında yönetici onayı gereklidir.',
    text17: 'Kullanıcılar düzeli rotalarını değiştirmek istediğinde yönetici onayı gereklidir.',
    text18: 'Sürücü uygulamasına günlük rotaları gönderirken yolcu atanmamış olan durakları da dahil et.',
    skipStopsForNoShowRiders: 'Dinamik rotalarda gelmeyen yolcuların duraklarını atla.',
    recalculateRouteStopTimes: 'Rezervasyon olmayan duraklara göre rotaların durak saatlerini yeniden hesapla',
    checkVehiclesCampusZone: 'Araçların yerleşkeye girişlerinin kontrol edilmesi',
    ridersCanReserveEvenThoughOverCapacity: 'Kapasite dolu olsa da rezervasyon yapılmasına izin ver',
    blockDuplicateDemandPerDirection:
      'Kullanıcılar tüm rota gruplarında günde en fazla bir gidiş ve bir dönüş Near Demand talebi oluşturabilir.',
    text19: 'Kullanıcılar dinamik rota talebi yaparken yolcu sayısı seçebilir.',
    enableBikeReservations: 'Bisiklet rezervasyonlarını etkinleştir',
    enableWheelchairReservations: 'Tekerlekli sandalye rezervasyonlarını etkinleştir',
    text20:
      'Canlı Sefer Takibi ekranında ring rotaların tüm duraklarının zamanında performans değerleri toplam zamanında gerçekleşme özetlerine dahil edilsin.',
    text22: 'Kullanıcıların tercih edilen alma/bırakma noktalarından farklı adreslere rota aramasına izin ver.',
    sendAllRoutes: 'Yolcu rota arama ekranında “Tüm Rotalar” sekmesini göster',
    isDefaultAllRoutes: 'Rota arama ekranı varsayılan olarak “Tüm Rotalar” seçili açılsın',
    text23: 'APC Cihazı Mevcut',
    text24: 'Yolcu Sayımı İçin APC Kullan',
    shuttleBufferForArrivalTime:
      'Zamanında performans takibi için dikkate alınacak varış zamanı toleransı: {shuttleBufferForArrivalTime} dk',
    applyThresholdToFirstStop:
      'Geliş yönündeki rotalarda varış zamanı toleransı ilk durağa da uygulansın.',
    shuttleBufferForDepartureTime:
      'Zamanında performans takibi için dikkate alınacak kalkış zamanı toleransı: {shuttleBufferForDepartureTime} dk',
    defaultCoverageRadius: 'Durakların varsayılan kapsama yarıçapı {defaultCoverageRadius}',
    updateExistingStop: 'Mevcut durakları da yeni yarıçap değeri ile güncelle',
    text21: 'Sürücüler planlanan süre içinde görevleri için check-in yapmadığında yöneticiler bilgilendirilsin.',
    setSuspensionRule: 'Yolcu davranışına göre askıya alma kuralı belirle',
    repeatedNoShowEnabled: 'Dinamik servis hatlarında tekrarlayan binmedi durumu',
    repeatedNoShowCount: 'En az binmedi sayısı',
    repeatedNoShowPeriod: 'Zaman dilimi',
    repeatedNoShowAction: 'Aksiyon',
    repeatedNoShowActionEmail: 'Yolcu listesini yöneticilere e-posta ile gönder',
    repeatedNoShowActionSuspend: 'Servisten otomatik olarak askıya al',
    repeatedLateCancellationEnabled: 'Dinamik servis hatlarında tekrarlayan geç iptal durumu',
    repeatedLateCancellationCount: 'En az geç iptal sayısı',
    suspendFor: 'Askıya alma süresi',
    repeatedNoShowThresholdLoweredWarning:
      'Bu eşiği düşürmek, önceden etkilenmeyen bazı yolcuların işaretlenmesine veya askıya alınmasına neden olabilir. Devam etmek istiyor musunuz?',
    repeatedLateCancellationThresholdLoweredWarning:
      'Bu eşiği düşürmek, önceden etkilenmeyen bazı yolcuların işaretlenmesine veya askıya alınmasına neden olabilir. Devam etmek istiyor musunuz?',
    checkSamsaraOnVehicleAdd: "Araç eklerken Samsara'yı da kontrol et",
    showVehicleInfoBy: {
      message: 'Araç bilgilerini mobil uygulama üzerinde şuna göre göster',
      license: 'Araç plakası',
      vehicleId: 'Araç kısa adı',
    },
    commuteTimeOptionsByRouteGroupSchedule:
      'Mobil uygulamada kayıt sırasında kullanıcılara işe geliş-gidiş için seçilmiş rota gruplarına göre saat opsiyonlarını göster.',
    triggerGtfs: 'GTFS Tetikle',
    updateExistingStopSuccess: 'Mevcut duraklar başarıyla güncellendi',
    updateExistingStopError: 'Mevcut duraklar güncellenirken hata oluştu',
    userNotifications: 'Personel Bildirimleri',
    approachingNotification: 'Araç yaklaşıyor bildirimi',
    arrivalNotification: 'Araç durağa vardı bildirimi',
    bulkMessages: 'Toplu/tek bildirimler',
    announcements: 'Duyurular',
    ticketReplies: 'Ticket cevapları',
    driverVehicleChanges: 'Sürücü ve araç değişiklikleri',
    newRouteCreated: 'Yeni rota oluşturuldu',
    routeInstanceCancelled: 'Sefer iptal edildi',
    routeInstanceCancellationReverted: 'Sefer iptali geri alındı',
    reservationPorting: 'Rezervasyon taşıma',
    noShow: 'Binmedi',
    stopTimeChange: 'Durak saati değişikliği',
    waitlist: 'Bekleme listesi',
  },

  vanpoolText: {
    driverAndRiderAgeRequirements: {
      text1: 'Vanpool <strong>yolcularının</strong> minimum olması gereken yaş.',
      minimumAgeForRiders: 'Yolcular için minimum yaş',
      text2: 'Yolcular {age} yaşından büyük olmalı.',
      text3: 'Vanpool <strong>sürücülerinin</strong> minimum olması gereken yaş.',
      minimumAgeForDrivers: 'Sürücüler için minimum yaş',
      text4: 'Sürücüler {age} yaşından büyük olmalı.',
    },
    driverLicenceRequirements: {
      text1: 'Vanpool <strong>sürücüleri</strong> için ehliyet yaş sınırının olması.',
      text2: 'Vanpool sürücüleri min {age} yıl ehliyete sahip olmalı.',
    },
    adminNotifications: {
      text2: 'Yolculuklar {riderCount} nın altında olursa adminleri bilgilendir',
      text3: 'Araçlardaki yolculuk harici km {distanceRatio} oranının üstünde olursa adminleri bilgilendir',
      text6: 'Telematik cihazlar araçlardan söküldüğünde adminleri bilgilendir',
      text7: 'Bir yolcu yeni vanpool talebi yaptığında yöneticileri bilgilendir.',
    },
  },
  driverAndRiderAgeRequirements: 'Sürücü ve Yolcu Yaş Gerekliliği',
  driverLicenceRequirements: 'Sürücü Ehliyet Gerekliliği',
  adminNotifications: 'Admin Bilgilendirmeleri',
  carpoolText: {
    unitPricePerMile: 'Mil başına birim fiyat.',
    matchUserType: 'Carpool eşleşmesini kullanıcı tipine göre kısıtla',
    matchUserTypeInfo: 'Açık olduğunda personel yalnızca aynı kullanıcı tipindeki personelle eşleşir.',
  },
  adminsToBeNotified: 'Bilgilendirilecek yöneticiler',
  notifyAdmins: 'Yöneticileri bilgilendir',
  recipientAdminEmails: 'Bilgilendirilecek yönetici e-posta adresleri',
  clearSelection: 'Seçimi Temizle',
  addNewCompany: 'Yeni Şirket Ekle',
  addNewSubCompany: 'Yeni Alt Şirket Ekle',
  addNewRegion: 'Yeni Bölge Ekle',
  mainCompany: 'Ana Şirket',
  thirdParty: 'Üçüncü Parti',
  companyName: 'Şirket Adı',
  taxNumber: 'Vergi Numarası',
  selectIndustry: 'Endüstri Seç',
  selectCompany: 'Şirket Seç',
  confirmMessage: 'Yaptığın değişiklikleri kaydetmek istiyor musun?',
  gtfsSuccessMessage: 'GTFS başarıyla tetiklendi.',
  deleteMessageText: 'Devam etmek istediğine emin misin?',
  continueMessage: 'Devam etmek istediğine emin misin?',
  noServiceProviderMessage: 'Servis sağlayıcı henuz eklenmedi.',
  noAdminAddedYet: 'Henüz adminler eklenmedi.',
  noCampusesAddedYet: 'Henüz Kampüs Eklenmedi',
  noRegionsAddedYet: 'Henüz Bölge Eklenmedi',
  noServiceProvidersAddedYet: 'Henüz Servis Sağlayıcı Eklenmedi',
  noSubCompaniesDefinedYet: 'Alt Şirketler Henüz Tanımlanmadı',
  confirmContinueMessage: 'Devam etmek istiyor musunuz?',
  flexiRideNotifications: 'flexiRide Bildirimler',
  corporateRiders: 'Kurumsal Personeller',
  flexiRideAssitants: 'flexiRide Asistan',
  pushNotification: 'Bildirim',
  Sms: 'SMS',
  business: 'İş',
  personal: 'Kişisel',
  purposeDescription: 'Amaç Açıklaması',
  estimatedServiceTime: 'Tahmini Hizmet Süresi',
  newPurpose: 'Yeni Amaç',
  flexiRideAssistants: 'flexiRide Yardımcıları',
  serviceProviders: 'Servis Şirketleri',
  companyDomainAddress: 'Şirket domaini',
  timeZone: 'Saat dilimi',
  flexiShuttleDocuments: 'flexiShuttle Dokümanları',
  typeTopicTitle: 'Konu başlığı',
  dismissMessage: 'Paneli kapatmak istediğinizden emin misiniz? Kaydedilmemiş tüm değişiklikler kaybolacaktır.',
  openingPage: 'Açılış Sayfası',
  selectOpeningPage: 'Bir açılış sayfası seçiniz',
  sendWelcomeEmail: 'Hoşgeldin Maili Gönder',
  welcomeEmailWillBeSentToAdmin: '{0} adlı yöneticiye hoşgeldin maili gönderilecektir.',
  welcomeEmailSentToAdmin: 'Hoşgeldin maili başarıyla gönderildi.',
  cancelRequestMessage:
    '{0} tarihinde saat {1} için bulunan paylaşımlı sürücülü araç talebinizi iptal etmek istiyor musunuz?',
  TBD: 'Atanacak',
  messageToBeDisplayedOnTheRiderApp: 'Sürücü uygulamasında görüntülenecek mesaj',
  pause: 'Duraklat',
  pausedBetween: 'Duraklatıldı',
  from: 'Başlangıç Tarihi',
  until: 'Bitiş Tarihi',
  reactivatePausedModuleMessage:
    'Hizmetiniz {date} tarihine kadar askıya alınmıştır. Daha erken etkinleştirmek istediğinizden emin misiniz?',
  moduleReactivatedSuccessfully: 'Modül başarıyla yeniden etkinleştirildi.',
  userProfiles: 'Kullanıcı Profilleri',
  userProfilesText: {
    organizationMember: 'Çalışan',
    guest: 'Misafir',
    addUserType: 'Kullanıcı Türü Ekle',
    userTypeName: 'Tür Adı',
    userTypeNamePlaceholder: 'örn. Tam Zamanlı',
    userTypeNameRequired: 'Kullanıcı türü adı gereklidir.',
    moduleAccess: 'Modül Erişimi',
    deleteUserType: 'Sil',
    deleteUserTypeConfirm: 'Bu kullanıcı türünü silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.',
    noUserTypes: 'Henüz kullanıcı türü tanımlanmamış.',
    savingUserType: 'Kaydediliyor…',
    userTypeSaved: 'Kullanıcı türü başarıyla kaydedildi.',
    userTypeDeleted: 'Kullanıcı türü başarıyla silindi.',
    addUserTypeTitle: 'Yeni Kullanıcı Türü',
    cancel: 'İptal',
    add: 'Ekle',
  },
};
